export * from "./hotel-seo-content";
export * from "./hotel-seo-content.types";
